import { NextPage } from 'next';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Layout from '~/src/features/_layout';
import PackagesLayout from '~/src/features/domru-tv/packages';
import { isShowcaseAbnEnabled } from '~/src/features/showcase/constants/abnVariants';
import { initialProps } from '~/src/helpers/basePageFunc';
import { nonPermanentRedirect } from '~/src/helpers/url';
import { selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    cityIn: string,
    companyName: string,
}

const DomRuTvPackagesPage: NextPage<IProps> = ({ cityIn, companyName }) => {
    return (
        <Layout
            title={`Подключить пакеты цифрового телевидения от ${companyName} в ${cityIn} | Пакеты платных ТВ каналов`}
            description={`Подключить пакеты платных цифровых каналов у провайдера ${companyName} в ${cityIn}. Интерактивные ТВ каналы на любую тематику: музыка, спорт, кино, сериалы. Узнайте больше на нашем сайте.`}
            withMenu={true}
            withFooter={true}
            withChat={true}
            bgColor={COLORS.BgMain}
        >
            <PackagesLayout/>
        </Layout>
    );
};

DomRuTvPackagesPage.getInitialProps = async(options) => {
   const { validatedAccessToken } = await initialProps(options, { isNeedAuthData: true });

    const { store, res } = options;
    const state = store.getState();
    const {
        city: {
            currentCity: { cityIn },
        },
    } = state;
    const companyName = selectCompanyName(state);
    const isShowcaseEnabled = isShowcaseAbnEnabled();

    if (isShowcaseEnabled && validatedAccessToken) {
        nonPermanentRedirect({ res, location: '/subscriptions' });
    }

    return { cityIn, companyName };
};

export default DomRuTvPackagesPage;
